import { ExchangeStatus } from './constants.js';
export class ExchangeModule {
    #exchangeStatusAtom;
    #subscriptions = [];
    #ordersAtom;
    constructor(params) {
        const { exchangeStatusAtom, ordersAtom } = params;
        this.#exchangeStatusAtom = exchangeStatusAtom;
        this.#ordersAtom = ordersAtom;
    }
    #handleOrdersAtomChange = async (orders) => {
        if (orders.size === 0)
            return;
        const exchangeStatus = await this.#exchangeStatusAtom.get();
        if (!exchangeStatus?.orderId) {
            return;
        }
        const order = orders.get(exchangeStatus.orderId);
        if (!order) {
            return;
        }
        if (order.status === 'complete-verified') {
            void this.#exchangeStatusAtom.set({ ...exchangeStatus, status: ExchangeStatus.COMPLETE });
        }
        else if (order.status === 'failed-final') {
            void this.#exchangeStatusAtom.set({ ...exchangeStatus, status: ExchangeStatus.FAILED });
        }
    };
    load = () => {
        this.#subscriptions.push(this.#ordersAtom.observe(this.#handleOrdersAtomChange));
    };
    stop = () => {
        this.#subscriptions.forEach((unsubscribe) => unsubscribe());
        this.#subscriptions = [];
    };
}
const exchangeModuleFactory = (args) => new ExchangeModule({ ...args });
const exchangeModuleDefinition = {
    id: 'exchangeModule',
    type: 'module',
    factory: exchangeModuleFactory,
    dependencies: ['exchangeStatusAtom', 'ordersAtom'],
    public: true,
};
export default exchangeModuleDefinition;
